import { arrayBufferDownload, arrayBufferDownloadExcel, downloadCSV } from "../../../../utils/download";
import { decorateEmptyGridValues, setColumnDefaultExtraProps } from "../../../../utils/table/gridUtils";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_RATEADMIN_RATEPLAN_LIST,
  TOAST,
  FETCH_RATEADMIN_RATEPLAN_INIT,
  FETCH_RATEADMIN_RATEPLAN_DETAIL,
  EXPORT_RATEADMIN_RATEPLAN,
  CREATE_RATEADMIN_RATEPLAN,
  EDIT_RATEADMIN_RATEPLAN,
  INIT_CREATE_RATEADMIN_RATEPLAN_SCREEN,
  RATEADMIN_RATEPLANDD,
  DELETE_RATEADMIN_RATEPLAN,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  RATEADMIN_RATEPLAN_SAVE_TABLE_STATE
} from "../../../types/rateadminrateplan.type";



const formFieldValueMap = {
  id: null,
  modBy: "",
  modTime: "",
  status: 1,
  title: "",
  userId: ""
};

const INITIAL_STATE = {
  rateAdminRatePlanListview: [],
  RatePlanDD: [],
  isRateAdminRatePlanDDSuccess: false,
  isRateAdminRatePlanDDError: false,
  isLoading: false,
  error: null,
  formFieldValueMap,
  isRateAdminRatePlanCreateSuccess: false,
  isRateAdminRatePlanCreateError: false,
  isRateAdminRatePlanDetailSuccess: false,
  isRateAdminRatePlanDetailError: false,
  isRateAdminRatePlanEditSuccess: false,
  isRateAdminRatePlanEditError: false,
  isRateAdminRatePlanExportSuccess: false,
  isRateAdminRatePlanExportError: false,
  isUploadImageSuccess: false,
  isUploadImageError: false,
  imageUploadResponse: null,
  // Table state persistence for filter restoration
  savedTableState: null
};

const tranformToGridView = (data) => {
  const rows = data.map((item) => {
    const {
      crtBy,
      crtTime,
      description,
      id,
      modBy,
      modTime,
      status,
      title
    } = item;

    const transformedValues = {
      crtBy,
      crtTime,
      description,
      id,
      modBy,
      modTime,
      status,
      title
    };
    const decoratedValues = {};
    Object.keys(transformedValues).forEach((key) => {
      decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
    });
    return decoratedValues;
  });

  const columns = [
    {
      colLabel: "ID",
      dataKey: "id",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Rate Plan",
      dataKey: "title",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Crt By",
      dataKey: "crtBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Crt Time",
      dataKey: "crtTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Mod By",
      dataKey: "modBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Edit Time",
      dataKey: "modTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    },
    {
      colLabel: "Status",
      dataKey: "status",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search..."
      }
    }
  ];

  return {
    datas: { columns, rows },
  };
};

export const rateadminRatePlanReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_RATEADMIN_RATEPLAN_INIT:
      // Preserve savedTableState when reinitializing to restore filters on back navigation
      return { ...INITIAL_STATE, isLoadingPage: true, savedTableState: state.savedTableState };
    case FETCH_RATEADMIN_RATEPLAN_DETAIL.START:
    case EXPORT_RATEADMIN_RATEPLAN.START:
    case UPLOAD_IMAGE.START:
    case FETCH_RATEADMIN_RATEPLAN_LIST.START:
    case CREATE_RATEADMIN_RATEPLAN.START:
    case EDIT_RATEADMIN_RATEPLAN.START:
    case RATEADMIN_RATEPLANDD.START:
    case DELETE_RATEADMIN_RATEPLAN.START:
      return { ...state, isLoading: true };

    case FETCH_RATEADMIN_RATEPLAN_LIST.SUCCESS: {
      const { page, data } = action.payload;

      let resetState = {
        rateAdminRatePlanListview: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isRateAdminRatePlanCreateSuccess: false,
        isRateAdminRatePlanCreateError: false,
        // Preserve savedTableState
        savedTableState: state.savedTableState,
      };
      if (!data) {
        return resetState;
      }
      const { number, size, totalElements, totalPages } = page;
      const { datas } = tranformToGridView(data);
      return {
        ...resetState,
        rateAdminRatePlanListview: datas,
        paginationInfo: {
          pageSize: size,
          totalRecords: totalElements,
          totalPages: totalPages,
          pageNumber: number,
        },
      };
    }
    case FETCH_RATEADMIN_RATEPLAN_LIST.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        rateAdminRatePlanListview: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
        israteadminRatePlanDeletionSuccess: false,
        israteadminRatePlanDeletionError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }

    case FETCH_RATEADMIN_RATEPLAN_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
            temp[key] = action.payload[key];
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isRateAdminRatePlanDetailSuccess: true,
      };
    }
    case FETCH_RATEADMIN_RATEPLAN_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminRatePlanDetailSuccess: false,
        isRateAdminRatePlanDetailError: true,
      };
    }

    //DD
    case RATEADMIN_RATEPLANDD.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        RatePlanDD: temp,
        isRateAdminRatePlanDDSuccess: true,
        isRateAdminRatePlanDDError: false,
      };
    }
    case RATEADMIN_RATEPLANDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminRatePlanDDSuccess: false,
        isRateAdminRatePlanDDError: true,
      };
    }
    //END DD


    // UPLOAD_IMAGE Start
    case UPLOAD_IMAGE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isUploadImageSuccess: false,
        isUploadImageError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case UPLOAD_IMAGE.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        imageUploadResponse: data,
        isUploadImageSuccess: true,
        isUploadImageError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // UPLOAD_IMAGE End

    // Export Start
    case EXPORT_RATEADMIN_RATEPLAN.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isRateAdminRatePlanExportSuccess: false,
        isRateAdminRatePlanExportError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case EXPORT_RATEADMIN_RATEPLAN.SUCCESS: {
      const data = action.payload;
      arrayBufferDownloadExcel(data, "rate-plan.xls");
      return {
        ...state,
        isRateAdminRatePlanExportSuccess: true,
        isRateAdminRatePlanExportError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // Export End

    // EDIT
    case EDIT_RATEADMIN_RATEPLAN.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminRatePlanEditSuccess: false,
        isRateAdminRatePlanEditError: true,
      };
    }

    case EDIT_RATEADMIN_RATEPLAN.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isRateAdminRatePlanEditSuccess: true,
        isRateAdminRatePlanEditError: false,
      };
    }

    // EDIT END

    // Create
    case INIT_CREATE_RATEADMIN_RATEPLAN_SCREEN: {
      // Preserve savedTableState when navigating to create/edit screen
      return { ...INITIAL_STATE, savedTableState: state.savedTableState };
    }

    case CREATE_RATEADMIN_RATEPLAN.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminRatePlanCreateSuccess: false,
        isRateAdminRatePlanCreateError: true,
      };
    }
    case CREATE_RATEADMIN_RATEPLAN.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isRateAdminRatePlanCreateSuccess: true,
        isRateAdminRatePlanCreateError: false,
      };
    }

    //End


    case TOAST.RESET: {
      return {
        ...state,
        isRateAdminRatePlanCreateSuccess: false,
        isRateAdminRatePlanCreateError: false,
        isRateAdminRatePlanEditError: false,
        isRateAdminRatePlanEditSuccess: false,
        isRateAdminRatePlanDetailError: false
      };
    }

    case DELETE_RATEADMIN_RATEPLAN.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isRateAdminRatePlanDeleteSuccess: true,
        isRateAdminRatePlanDeleteError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    case DELETE_RATEADMIN_RATEPLAN.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isRateAdminRatePlanDeleteSuccess: false,
        isRateAdminRatePlanDeleteError: true,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }
    case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY:
      return {
        ...state,
        shouldOpenDeleteConfirmationPopup: action.payload,
        isRateAdminRatePlanDeleteSuccess: false,
        isRateAdminRatePlanDeleteError: false,
      };

    // Save table state (filters, pagination, sort) for restoration

    case RATEADMIN_RATEPLAN_SAVE_TABLE_STATE: {
      return {
        ...state,
        savedTableState: action.payload,
      };
    }

    default:
      return state;
  }
};
